import axios from 'axios'

const uploadCalls = {
  // v2 ---------
  api_v2_poker_hand_history_text({ commit, dispatch, getters }, data) {
    const url = 'https://blog.gtowizard.com/suported-sites-and-formats-for-hh-analyzer/'
    dispatch('api_call', {
      apiVersion: 'v4',
      endpoint: 'hand-history/upload-text/',
      method: 'POST',
      hasCancel: false,
      action: 'poker_show_analyzed_handV2', // todo update action to show hand detail
      mutation: 'api_v2_poker_hand_history_text',
      message: {
        type: 'error',
        hide: false,
        statusMessages: {
          _400: {
            i18n: 'analyze.upload.hand.status_400',
            use_response_error_type: true,
            i18nKey: 'analyze.upload.hand.error_', // + response_error_type
            link: {
              url,
              i18n: 'common.read_more_here',
            },
          },
          _500: {
            i18n: 'analyze.upload.hand.status_500',
            link: {
              url,
              i18n: 'common.read_more_here',
            },
          },
          _429: {
            i18n: 'analyze.upload.hand.status_429',
            link: {
              url,
              i18n: 'common.read_more_here',
            },
          },
        },
      },
      data,
    })
  },
  async api_v2_poker_upload_file(
    { commit, rootState, dispatch, getters },
    { file, callId, startTime, status },
  ) {
    const uploadItem = {
      callId,
      startTime,
      status,
      file,
    }

    dispatch('api_update_upload', {
      ...uploadItem,
      status: 'progress',
    })

    const res = await dispatch('api_call', {
      apiVersion: 'v2',
      method: 'POST',
      endpoint: 'poker/hand-history/files/',
      hasCancel: false,
      data: {
        filename: file.name,
      },
    })

    // --dev only -- random failed uploads - keep it here in comments
    // const randomNumber = Math.floor(Math.random() * 1000)
    // if (randomNumber % 2 === 0) {
    //   res = { response: { status: 999 } }
    // }

    if (res.response?.status === 200) {
      const { fields, url, uuid } = res.response.data
      // https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html
      // keep the order (file must be at last position)
      const formData = new FormData()
      // Key to upload:
      formData.append('key', fields.key)

      // console.log(file)
      // mozzila dont get file.type on folder drop
      const type = file.name.includes('xml') ? 'text/xml' : 'text/plain'

      // Content-Type:
      formData.append('Content-Type', type)
      formData.append('X-Amz-Credential', fields['x-amz-credential'])
      formData.append('X-Amz-Algorithm', fields['x-amz-algorithm'])
      formData.append('X-Amz-Date', fields['x-amz-date'])
      // Tags for File:
      formData.append('policy', fields.policy)
      formData.append('X-Amz-Signature', fields['x-amz-signature'])
      formData.append('X-Amz-Storage-Class', fields['x-amz-storage-class'])
      if (fields['x-amz-security-token']) {
        formData.append('X-amz-security-token', fields['x-amz-security-token'])
      }
      // File:
      formData.append('file', file)

      let aws_res = { status: 500 }
      try {
        aws_res = await axios({
          method: 'post',
          url,
          data: formData,
          headers: {
            'content-type': 'multipart/form-data',
            'x-amz-storage-class': fields['x-amz-storage-class'],
          },
        })
      } catch (error) {
        console.error('Error uploading:', error)
      }
      if (aws_res?.status === 200 || aws_res?.status === 204) {
        dispatch('api_update_upload', {
          ...uploadItem,
          status: 'finished',
        })
        setTimeout(() => {
          dispatch('api_upload_next_file')
        })
      } else {
        if (aws_res?.status !== 0) {
          await dispatch('api_call', {
            apiVersion: 'v2',
            method: 'PATCH',
            endpoint: `poker/hand-history/files/${uuid}`,
            data: {
              status: 'ERROR',
            },
            hasCancel: false,
          })
        }

        dispatch('api_update_upload', {
          ...uploadItem,
          status: 'error',
        })
        setTimeout(() => {
          dispatch('api_upload_next_file')
        })
      }
    } else {
      dispatch('api_update_upload', {
        ...uploadItem,
        status: 'error',
      })
      setTimeout(() => {
        dispatch('api_upload_next_file')
      })
    }
  },
}

export default uploadCalls
